import { Controller } from '@hotwired/stimulus'

export class TaskMemberDropdownController extends Controller<HTMLDivElement> {
  static targets = ['button', 'link', 'newTabLink', 'buttonGroup']

  declare readonly buttonTarget: HTMLButtonElement
  declare readonly linkTarget: HTMLLinkElement

  private observer: MutationObserver | null = null

  connect(): void {
    this.observeButton()
  }

  disconnect(): void {
    this.observer?.disconnect()
  }

  private observeButton(): void {
    this.observer = new MutationObserver(mutations => {
      this.buttonChanged(mutations)
    })

    this.observer.observe(this.buttonTarget, {
      childList: true,
      subtree: true,
      characterData: true,
    })
  }

  private buttonChanged(_mutations: MutationRecord[]): void {
    const href = this.buttonTarget
      .querySelector('[data-selected-member]')
      ?.getAttribute('data-url')

    if (href) {
      this.linkTarget.href = href
    }
  }
}
